import React from 'react';
import {createRoot} from 'react-dom/client';
import Cart from '../../components/cart/Cart.jsx';
import JshModule from "@core/scripts/helper/jsh-module";

const {moduleScope, config} = JshModule('checkout/cart');

const {
    hideHeaderButton,
    footerText,
    footerSubmit,
    hideBenefits,
    hideBackButton,
    model,
    hideLoginHint,
    showErrorLayer
} = config;

createRoot(moduleScope).render(
    <Cart
        hideHeaderButton={hideHeaderButton}
        footerText={footerText}
        footerSubmit={footerSubmit}
        hideBenefits={hideBenefits}
        hideBackButton={hideBackButton}
        model={model}
        hideLoginHint={hideLoginHint}
        page={model.page}
        showErrorLayer={showErrorLayer}
        itemHeaderComponentSize="2"
        isLastCheckPage={false}
        recoParams={model.recoParams}
    />
);